import { combineReducers } from "redux";
import * as peticioEnCursReducer from "./peticioEnCurs";
import * as observadorsReducer from "./observadors";
import * as formulariReducer from "./formulari";

const rootReducer = combineReducers({
  peticioEnCurs: peticioEnCursReducer.default,
  dades: observadorsReducer.default,
  formulari: formulariReducer.default
});

export default rootReducer;

export const getPeticioEnCurs = state =>
  peticioEnCursReducer.getPeticioEnCurs(state.peticioEnCurs);

export const getPeticioError = state => {
  peticioEnCursReducer.getPeticioError(state);
};

export const getObservadorsAsArray = state =>
  observadorsReducer.getObservadorsAsArray(state.dades);

export const getObservadorPerId = state =>
  observadorsReducer.getObservadorPerId(state.dades);

export const getDadesObservador = state =>
  observadorsReducer.getDadesObservador(state.dades);

export const getObservadorsActius = state =>
  observadorsReducer.getObservadorsActius(state.dades);

export const getObservadorsInactius = state =>
  observadorsReducer.getObservadorsInactius(state.dades);

export const getObservadorsUsuari = state =>
  observadorsReducer.getObservadorsUsuari(state.dades);

export const getObservadorsEspecies = state =>
  observadorsReducer.getObservadorsEspecies(state.dades);

export const getPeticioObservadorsError = state =>
  observadorsReducer.getPeticioObservadorsError(state.dades);

export const getIdObservador = state =>
  observadorsReducer.getIdObservador(state.dades);

export const getRols = state => observadorsReducer.getRolsUsuari(state.dades);
export const getMostrarErrors = state => state.formulari.mostrarErrors;
export const getDadesEditades = state => state.formulari.editades;
export const getDadesOriginals = state => state.formulari.originals;
export const getPeticioEnviarFormulariEnCurs = state =>
  state.formulari.peticioEnviarFormulariEnCurs;

export const getIndretsIndividusFenofases = state =>
  observadorsReducer.getIndretsIndividusFenofases(state);
